import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
import { useCallback } from "react";
import { EmailService } from "../../../../services/SubmissionService";

export default function Submission({
    submission,
}: {
    submission: APIModels.Submission;
}) {
    const never = "never" as const;
    const [updatedEmail, setUpdatedEmail] = useState(submission.emails ?? []);
    const [saving, setSaving] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        setUpdatedEmail(submission.emails ?? []);
    }, [submission]);

    const onSaveClick = useCallback(async () => {
        /* 
        setSaving(true);
        AttorneyService.SaveProfile({ body: request }).then(
            (resp) => {
                setSaving(false);
                if (resp.successful === true) {
                    setErrorMessage(resp.errorMessage ?? "");
                    if (resp.data?.length === 1) {
                        onSearchComplete(request, resp.data[0]);
                    } else if (resp.data && resp.data?.length > 1) {
                        //We will need to show the modal to select which case
                        setSearchResults(resp.data ?? []);
                    } else {
                        setErrorMessage(resp.errorMessage ?? "No case found");
                    }
                } else {
                    console.log(resp.errorMessage);
                    setErrorMessage(resp.errorMessage ?? "No case found");
                }
            },
            (error) => {
                setSaving(false);
                console.log(error);
                setErrorMessage("An error has occurred");
            }
        );
        */
    }, [updatedEmail]);

    const refreshData = () => {
        EmailService.getAll({
            id: submission?.id ?? "",
        }).then(
            (resp) => {
                if (resp?.successful && resp?.data !== null) {
                    setUpdatedEmail(resp?.data ?? updatedEmail);
                } else {
                    setUpdatedEmail(updatedEmail);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };

    return (
        <div className="card text-center">
            <div className="card-body">
                <div style={{ maxWidth: "100%", zIndex: -1 }}>
                    <MaterialTable
                        columns={[
                            {
                                title: "EMail",
                                field: "emailAddress",
                            },
                            {
                                title: "Name",
                                field: "name",
                            },
                        ]}
                        data={updatedEmail}
                        title="Email"
                        editable={{
                            onRowAdd: (newData) =>
                                new Promise((resolve, reject) => {
                                    EmailService.add({
                                        id: submission?.id ?? "",
                                        body: newData,
                                    }).then(
                                        (resp) => {
                                            if (resp?.successful) {
                                                refreshData();
                                            } else {
                                                setUpdatedEmail(
                                                    submission?.emails ?? []
                                                );
                                            }
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                }),
                            onRowUpdate: (newData, oldData) =>
                                new Promise((resolve, reject) => {
                                    EmailService.update({
                                        id: oldData?.submissionID ?? "",
                                        body: newData,
                                    }).then(
                                        (resp) => {
                                            if (resp?.successful) {
                                                refreshData();
                                            } else {
                                                setUpdatedEmail(
                                                    submission?.emails ?? []
                                                );
                                            }
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                }),
                            onRowDelete: (oldData) =>
                                new Promise((resolve, reject) => {
                                    EmailService.delete({
                                        id: oldData.submissionID ?? "",
                                        body: oldData,
                                    }).then(
                                        (resp) => {
                                            if (resp?.successful) {
                                                refreshData();
                                            } else {
                                                setUpdatedEmail(
                                                    submission?.emails ?? []
                                                );
                                            }
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                }),
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
